import { jsxs as e, jsx as l } from "react/jsx-runtime";
const h = ({ size: C = 100 }) => {
  const i = typeof C == "number";
  return /* @__PURE__ */ e(
    "svg",
    {
      width: i ? C : C.width,
      height: i ? C : C.height,
      viewBox: "0 0 100 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("g", { clipPath: "url(#clip0_28779_322121)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
              fill: "#F3F3FD"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M49.7778 26.5205C37.4778 26.5205 36.934 39.5518 37.5903 47.333H44.1528C44.1528 42.6455 42.6587 32.708 49.7778 32.708C56.809 32.708 55.4028 41.708 55.4028 47.333H62.3402C63.2778 40.3955 62.0778 26.5205 49.7778 26.5205Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M28.6667 52.6663C28.6667 49.7208 31.0546 47.333 34.0001 47.333H66.0001C68.9456 47.333 71.3334 49.7208 71.3334 52.6663V68.6663C71.3334 71.6119 68.9456 73.9997 66.0001 73.9997H34.0001C31.0546 73.9997 28.6667 71.6119 28.6667 68.6663V52.6663Z",
              fill: "var(--plac-icon-fill-active)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M36.6667 47.3333V39.3333C36.6667 31.9695 42.6363 26 50.0001 26C57.3639 26 63.3334 31.9695 63.3334 39.3333V47.3333H66.0001C68.9456 47.3333 71.3334 49.7211 71.3334 52.6667V68.6667C71.3334 71.6122 68.9456 74 66.0001 74H34.0001C31.0546 74 28.6667 71.6122 28.6667 68.6667V52.6667C28.6667 49.7211 31.0546 47.3333 34.0001 47.3333H36.6667ZM61.3334 47.3067V39.3333C61.3334 33.0741 56.2593 28 50.0001 28C43.7409 28 38.6667 33.0741 38.6667 39.3333V47.3067H43.3334V39.3333C43.3334 35.6514 46.3182 32.6667 50.0001 32.6667C53.682 32.6667 56.6667 35.6514 56.6667 39.3333V47.3067H61.3334ZM45.3334 39.3333V47.3067H54.6667V39.3333C54.6667 36.756 52.5774 34.6667 50.0001 34.6667C47.4228 34.6667 45.3334 36.756 45.3334 39.3333ZM69.3334 52.6667C69.3334 50.8257 67.841 49.3333 66.0001 49.3333H34.0001C32.1591 49.3333 30.6667 50.8257 30.6667 52.6667V68.6667C30.6667 70.5076 32.1591 72 34.0001 72H66.0001C67.841 72 69.3334 70.5076 69.3334 68.6667V66H59.0001C58.4478 66 58.0001 65.5523 58.0001 65C58.0001 64.4477 58.4478 64 59.0001 64H69.3334V60.6667H59.0001C58.4478 60.6667 58.0001 60.219 58.0001 59.6667C58.0001 59.1144 58.4478 58.6667 59.0001 58.6667H69.3334V55.3333H59.0001C58.4478 55.3333 58.0001 54.8856 58.0001 54.3333C58.0001 53.781 58.4478 53.3333 59.0001 53.3333H69.3334V52.6667Z",
              fill: "var(--plac-primary-gray)"
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_28779_322121", children: /* @__PURE__ */ l("rect", { width: "100", height: "100", fill: "white" }) }) })
      ]
    }
  );
};
export {
  h as LockIllustration
};
//# sourceMappingURL=index.es487.js.map
